module.exports = __webpack_public_path__ + "static/media/ZTT.8315ba34.pdf";